export enum CountryCode {
  USA = 'US',
  CANADA = 'CA',
}
